import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { RouterConfig, useIsFrontendStyleDefault, useIsFrontendStyleRed } from '@edikk-edikk/country-frontend';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { CityForSelectType } from '#home/types';
import cardLocationCityChooserHolderCss from '../assets/card-location-city-chooser-holder.module.scss';
import { AppSvgSpriteMonoIcon } from '#src/svg';

type PropsType = {
  selectedCity: CityForSelectType|null;
};

const CardLocationCityChooserHolderButton: FC<PropsType> = ({
  selectedCity,
}) => {
  const navigate = useNavigate();
  const isFrontendStyleDefault = useIsFrontendStyleDefault();
  const isFrontendStyleRed = useIsFrontendStyleRed();

  const handlerClick = useCallback(() => {
    if (!selectedCity) {
      return;
    }

    navigate(selectedCity.url, {
      state: {
        routerConfig: RouterConfig.initForCity(selectedCity.value),
      },
    });
  }, [navigate, selectedCity]);

  return (
    <Button
      variant={ButtonVariant.unstyled}
      onClick={handlerClick}
      aria-label="Go"
      textBlack={isFrontendStyleDefault}
      textWhite={isFrontendStyleRed}
      disabled={!selectedCity}
    >
      <AppSvgSpriteMonoIcon
        name="arrow-right"
        className={cardLocationCityChooserHolderCss.cardLocationCityChooserHolder__buttonIcon}
      />
    </Button>
  );
};

export { CardLocationCityChooserHolderButton };
